/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Just_LaunchedInputs */

const en_directory_detail_just_launched = /** @type {(inputs: Directory_Detail_Just_LaunchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just launched`)
};

const zh_directory_detail_just_launched = /** @type {(inputs: Directory_Detail_Just_LaunchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新上线`)
};

/**
* | output |
* | --- |
* | "Just launched" |
*
* @param {Directory_Detail_Just_LaunchedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_just_launched = /** @type {((inputs?: Directory_Detail_Just_LaunchedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Just_LaunchedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_just_launched(inputs)
	return zh_directory_detail_just_launched(inputs)
});
export { directory_detail_just_launched as "directory.detail.just_launched" }